/** @format */

import React, { Component } from 'react';
import { Divider } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';

@inject('StatsStore')
@observer
class MostRequestPartsCars extends Component {
  renderPartList = mostRequestPartsCars => {
    return mostRequestPartsCars.map(part => {
      return (
        <div className="simple-list" key={part.name}>
          <div className="simple-list-item">
            <div>{part.name}</div>
            <div>{part.value}</div>
          </div>
          <Divider fitted />
        </div>
      );
    });
  };

  render() {
    const { StatsStore } = this.props;
    const mostRequestPartsCars = StatsStore.mostRequestPartsCars;
    return <div>{this.renderPartList(mostRequestPartsCars)}</div>;
  }
}

export default MostRequestPartsCars;
